var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutritionalYeast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#325CA7;}\n\t.st1{fill:#EFC05D;}\n\t.st2{fill:#F8EEE1;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#F3CD81;}\n\t.st5{fill:#E8B54A;}\n\t.st6{fill:#F6DAA2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.19,184.66c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.89,150.37,62.5,184.66,105.19,184.66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 82.64,
    y: 73.96,
    className: "st1",
    width: 42.41,
    height: 11.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.23,83.36H78.45c-5.85,0-10.59,4.74-10.59,10.59v50.78c0,5.85,4.74,10.59,10.59,10.59h50.78 c5.85,0,10.59-4.74,10.59-10.59V93.95C139.82,88.1,135.08,83.36,129.23,83.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.29,76.64h45.1c2.9,0,5.25-2.35,5.25-5.25v-6.03c0-2.9-2.35-5.25-5.25-5.25h-45.1 c-2.9,0-5.25,2.35-5.25,5.25v6.03C76.05,74.29,78.4,76.64,81.29,76.64z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.74,
    y: 96,
    className: "st3",
    width: 72.04,
    height: 43.99
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.09,107.9c0,3.64-6.61,17.3-13.45,18.63c-3.85,0.74-8.81,1.24-12.41,1.54 c-1.94-1.37-3.36-3.01-4.01-3.96c-1.08-1.57,7.77-8.02,13.31-14.63c5.54-6.61,10.34-8.35,13.8-6.7c0.35,0.17,0.79,0.48,1.3,0.91 c0,0,0,0,0,0v0C109.51,104.94,110.09,106.27,110.09,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.66,124.65c-1.9,1.48-16.42,7.29-29.02,5.95c0,0,0,0-0.01,0c-0.54-0.09-1.09-0.16-1.67-0.22 c-2.18-0.22-4.14-1.18-5.74-2.32c3.6-0.29,8.57-0.79,12.41-1.54c6.83-1.32,13.45-14.99,13.45-18.63c0-1.63-0.57-2.96-1.45-4.21 c2.58,2.16,6.95,7.27,10.89,11.8C120.77,118.6,122.13,123.51,120.66,124.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M118.16,130.46c-4.3,1.41-11.07,1.24-15.38,1.66c-3.78,0.36-7.12-0.88-11.14-1.52 c12.6,1.34,27.12-4.48,29.02-5.95c1.46-1.14,0.11-6.05-1.14-9.17c2.94,3.38,5.63,6.44,7.15,7.71 C130.64,126.5,122.46,129.06,118.16,130.46z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.54,124.86c0.66,0,0.66-1.03,0-1.03C85.88,123.83,85.88,124.86,86.54,124.86L86.54,124.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.1,127.55c0.66,0,0.66-1.03,0-1.03C88.44,126.52,88.44,127.55,89.1,127.55L89.1,127.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.95,121.6c0.66,0,0.66-1.03,0-1.03C91.29,120.57,91.29,121.6,91.95,121.6L91.95,121.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M94.97,125.94c0.66,0,0.66-1.03,0-1.03C94.31,124.91,94.31,125.94,94.97,125.94L94.97,125.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M98.61,129.41c0.66,0,0.66-1.03,0-1.03C97.95,128.38,97.95,129.41,98.61,129.41L98.61,129.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M105.51,129.57c0.66,0,0.66-1.03,0-1.03C104.85,128.55,104.85,129.57,105.51,129.57L105.51,129.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.55,129.74c0.66,0,0.66-1.03,0-1.03C114.89,128.71,114.89,129.74,115.55,129.74L115.55,129.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.48,124.49c0.66,0,0.66-1.03,0-1.03C113.82,123.46,113.82,124.49,114.48,124.49L114.48,124.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M112.79,123.33c0.66,0,0.66-1.03,0-1.03C112.12,122.31,112.12,123.33,112.79,123.33L112.79,123.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M119.98,121.47c0.66,0,0.66-1.03,0-1.03C119.32,120.45,119.32,121.47,119.98,121.47L119.98,121.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.16,122.46c0.66,0,0.66-1.03,0-1.03C122.5,121.44,122.5,122.46,123.16,122.46L123.16,122.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M122,126.68c0.66,0,0.66-1.03,0-1.03C121.34,125.65,121.34,126.68,122,126.68L122,126.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M116.63,115.69c0.66,0,0.66-1.03,0-1.03C115.97,114.66,115.97,115.69,116.63,115.69L116.63,115.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M107.21,111.22c0.66,0,0.66-1.03,0-1.03C106.54,110.2,106.54,111.22,107.21,111.22L107.21,111.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M100.63,116.51c0.66,0,0.66-1.03,0-1.03C99.97,115.49,99.97,116.51,100.63,116.51L100.63,116.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.13,113.49c0.66,0,0.66-1.03,0-1.03C95.47,112.47,95.47,113.49,96.13,113.49L96.13,113.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M103.24,106.43c0.66,0,0.66-1.03,0-1.03C102.58,105.4,102.58,106.43,103.24,106.43L103.24,106.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111.55,110.48c0.66,0,0.66-1.03,0-1.03C110.88,109.45,110.88,110.48,111.55,110.48L111.55,110.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M112.74,117.96c0.66,0,0.66-1.03,0-1.03C112.08,116.93,112.08,117.96,112.74,117.96L112.74,117.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M108.61,123c0.66,0,0.66-1.03,0-1.03C107.95,121.97,107.95,123,108.61,123L108.61,123z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M99.85,119.98c0.66,0,0.66-1.03,0-1.03C99.19,118.96,99.19,119.98,99.85,119.98L99.85,119.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M105.59,108.33c0.66,0,0.66-1.03,0-1.03C104.93,107.3,104.93,108.33,105.59,108.33L105.59,108.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M103.2,114.32c0.66,0,0.66-1.03,0-1.03C102.54,113.29,102.53,114.32,103.2,114.32L103.2,114.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.92,111.72c0.66,0,0.66-1.03,0-1.03C100.26,110.69,100.26,111.72,100.92,111.72L100.92,111.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.54,116.88c0.66,0,0.66-1.03,0-1.03C95.88,115.86,95.88,116.88,96.54,116.88L96.54,116.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.33,115.44c0.66,0,0.66-1.03,0-1.03C90.67,114.41,90.67,115.44,91.33,115.44L91.33,115.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.07,119.53c0.66,0,0.66-1.03,0-1.03C87.41,118.5,87.41,119.53,88.07,119.53L88.07,119.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.43,119.2c0.66,0,0.66-1.03,0-1.03C93.77,118.17,93.77,119.2,94.43,119.2L94.43,119.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.78,128.62c0.66,0,0.66-1.03,0-1.03C118.12,127.6,118.12,128.62,118.78,128.62L118.78,128.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.02,124.7c0.66,0,0.66-1.03,0-1.03C124.36,123.67,124.36,124.7,125.02,124.7L125.02,124.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M105.1,117.13c0.66,0,0.66-1.03,0-1.03C104.44,116.11,104.44,117.13,105.1,117.13L105.1,117.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.41,124.49c0.66,0,0.66-1.03,0-1.03C122.75,123.46,122.75,124.49,123.41,124.49L123.41,124.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.7,125.03c0.66,0,0.66-1.03,0-1.03C107.04,124,107.04,125.03,107.7,125.03L107.7,125.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.55,114.03c0.66,0,0.66-1.03,0-1.03C109.89,113.01,109.89,114.03,110.55,114.03L110.55,114.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.6,119.38c0.03,0.03,0.06,0.06,0.08,0.08c0.05,0.05,0.1,0.09,0.17,0.11c0.06,0.03,0.13,0.05,0.2,0.04 c0.07,0,0.14-0.01,0.2-0.04c0.06-0.02,0.12-0.06,0.17-0.11c0.03-0.03,0.05-0.07,0.08-0.1c0.05-0.08,0.07-0.17,0.07-0.26 c-0.01-0.05-0.01-0.09-0.02-0.14c-0.02-0.09-0.07-0.16-0.13-0.23c-0.03-0.03-0.06-0.06-0.08-0.08c-0.05-0.05-0.1-0.09-0.17-0.11 c-0.06-0.03-0.13-0.05-0.2-0.04c-0.07,0-0.14,0.01-0.2,0.04c-0.06,0.02-0.12,0.06-0.17,0.11c-0.03,0.03-0.05,0.07-0.08,0.1 c-0.05,0.08-0.07,0.17-0.07,0.26c0.01,0.05,0.01,0.09,0.02,0.14C116.49,119.24,116.53,119.31,116.6,119.38L116.6,119.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.31,130.23c0.66,0,0.66-1.03,0-1.03C109.64,129.21,109.64,130.23,110.31,130.23L110.31,130.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.77,123.33c0.66,0,0.66-1.03,0-1.03C98.11,122.31,98.11,123.33,98.77,123.33L98.77,123.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.01,123.87c0.66,0,0.66-1.03,0-1.03C105.35,122.84,105.35,123.87,106.01,123.87L106.01,123.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.35,118.66c0.66,0,0.66-1.03,0-1.03C109.69,117.63,109.68,118.66,110.35,118.66L110.35,118.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.73,123.87c0.66,0,0.66-1.03,0-1.03C104.07,122.84,104.06,123.87,104.73,123.87L104.73,123.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105.68,115.89c0.66,0,0.66-1.03,0-1.03C105.02,114.87,105.01,115.89,105.68,115.89L105.68,115.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.33,122.26c0.66,0,0.66-1.03,0-1.03C116.67,121.23,116.67,122.26,117.33,122.26L117.33,122.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.83,104.9c0.66,0,0.66-1.03,0-1.03C107.16,103.87,107.16,104.9,107.83,104.9L107.83,104.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100.47,107.42c0.66,0,0.66-1.03,0-1.03C99.81,106.39,99.81,107.42,100.47,107.42L100.47,107.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.83,109.4c0.66,0,0.66-1.03,0-1.03C96.17,108.38,96.17,109.4,96.83,109.4L96.83,109.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.7,126.84c0.66,0,0.66-1.03,0-1.03C102.04,125.82,102.04,126.84,102.7,126.84L102.7,126.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.28,119.41c0.66,0,0.66-1.03,0-1.03C102.62,118.38,102.62,119.41,103.28,119.41L103.28,119.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.25,119.82c0.66,0,0.66-1.03,0-1.03C106.59,118.79,106.59,119.82,107.25,119.82L107.25,119.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.85,111.06c0.66,0,0.66-1.03,0-1.03C104.19,110.03,104.19,111.06,104.85,111.06L104.85,111.06z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionalYeast);
export default __webpack_public_path__ + "static/media/Nutritional_yeast.e2374175bc2eca9116f0ab6c04462159.svg";
export { ForwardRef as ReactComponent };